module.exports = __webpack_public_path__ + "img/s5_stepimg03@2x.715ae109.png";